module.exports = __webpack_public_path__ + "static/media/jeff2.e17d8714.jpg";